'use client';

import { Fragment, ReactNode } from 'react';
import { useSession } from '@clerk/nextjs';

export function MultiSessionSupportProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { session } = useSession();
  if (!children) {
    return null;
  }
  return (
    <Fragment key={session ? session.id : 'no-users'}>{children}</Fragment>
  );
}
